import { Button } from 'antd';

import { Icon } from '@/components/Icon';

type Props = {
  currentSlide: number;
  handlePrev: () => void;
};

export const BackButton: React.FC<Props> = ({ currentSlide, handlePrev }) => {
  return (
    <Button
      type="text"
      icon={<Icon i="ChevronLeft" />}
      onClick={handlePrev}
      disabled={currentSlide === 0}
    />
  );
};
